import { PRIVACY, TERMS, type LegalDoc } from '../lib/legal';
import { LegalFooter } from '../components/LegalFooter';
import '../styles/legal.css';

/**
 * Legal — the /privacy and /terms screens (card cEchedAassmt).
 *
 * A standalone full-page screen: main.tsx swaps it in for <App /> when the
 * pathname is /privacy or /terms, so the legal pages load no session, make no
 * API calls, and never touch the pair screen. Regular <a href> links (footer,
 * back link) do full navigations — the app has no client router, and a policy
 * page is the one place a reload is the right behaviour.
 *
 * Copy is the approved Runbook §8 text via lib/legal.ts, verbatim.
 */

interface Props {
  doc: LegalDoc;
}

export function Legal({ doc }: Props) {
  const other = doc.slug === 'privacy' ? TERMS : PRIVACY;
  return (
    <div className="pear-app" data-react-shell="legal">
      <header className="pear-header">
        <div className="pear-header-inner">
          <span className="pear-mark" />
          <h1 className="pear-title">Pear</h1>
        </div>
      </header>

      <main className="pear-main legal-main">
        <article className="legal-doc" data-legal-doc={doc.slug}>
          <p className="legal-kicker">Pear — legal</p>
          <h2 className="legal-title" id="legal-title">
            {doc.title}
          </h2>
          <p className="legal-note" id="legal-note">
            {doc.note}
          </p>
          <div className="legal-body" id="legal-body">
            {doc.paragraphs.map((p, i) => (
              <p key={i} className="legal-para">
                {p}
              </p>
            ))}
          </div>

          <nav className="legal-cross" aria-label="Other legal document">
            <a id="legal-cross-link" href={`/${other.slug}`}>
              Read the {other.title} →
            </a>
          </nav>

          <p className="legal-back">
            <a id="legal-back" href="/">
              ← Back to Pear
            </a>
          </p>
        </article>

        <LegalFooter variant="legal" />
      </main>
    </div>
  );
}
